
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArrowDownRight, ArrowUpRight, Boxes, Package, Truck, ArrowLeftRight, Building, Gift, Users } from "lucide-react";
import StatCard from "./StatCard";

const OverviewSection = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      <StatCard 
        title="Toplam Stok"
        value="15,842"
        description="2,145 farklı ürün"
        icon={<Package className="h-6 w-6 text-primary" />}
        trend={{ value: 12, isPositive: true }}
      />
      <StatCard 
        title="Giriş/Çıkış"
        value="3,521 / 2,954"
        description="Bu ay"
        icon={<ArrowLeftRight className="h-6 w-6 text-primary" />}
        trend={{ value: 8, isPositive: true }}
      />
      <StatCard 
        title="Depo Doluluk"
        value="%76"
        description="8 aktif depo"
        icon={<Building className="h-6 w-6 text-primary" />}
        trend={{ value: 5, isPositive: false }}
      />
      <StatCard 
        title="Bağışlar"
        value="1,245"
        description="₺854,213 değerinde"
        icon={<Gift className="h-6 w-6 text-primary" />}
        trend={{ value: 24, isPositive: true }}
      />
      <StatCard 
        title="Sevkiyatlar"
        value="43"
        description="12 devam ediyor"
        icon={<Truck className="h-6 w-6 text-primary" />}
        trend={{ value: 3, isPositive: true }}
      />
      <StatCard 
        title="Faydalanıcılar"
        value="18,243"
        description="3,421 aktif"
        icon={<Users className="h-6 w-6 text-primary" />}
        trend={{ value: 9, isPositive: true }}
      />
    </div>
  );
};

export default OverviewSection;
